import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import { TRANSITION_TIMEOUT } from 'common/constants/';
import PaintBrush from 'common/icons/PaintBrush';
import {
    colorAppBorder,
    colorAppLink,
    colorAppIcon,
    colorAppBackground,
    colorAppShadedBackground,
    colorAppSuccess,
} from 'common/styles/colors';
import {
    headlineSmallFontSize,
    subheadlineSmallFontSize,
    latoLetterSpacing,
    baseLineHeight,
} from 'common/styles/typography';
import {
    containerPaddingXs,
    containerPaddingM,
    buttonLargePaddingS,
    buttonMediumPaddingM,
    baseBorderWidth,
    baseShadowBlur,
    baseShadowCast,
} from 'common/styles/variables';

import { TICKET_SUB_LABEL_LAST_EDITED } from '../../constants/formStyleLabels';
import { TICKET_HEADER_QA } from '../../constants/ticketDataQa';

const TicketStylingTab = styled.div`
    padding: ${containerPaddingM};
    padding-left: ${buttonMediumPaddingM};
    border-style: solid;
    border-color: ${colorAppBorder};
    border-width: ${baseBorderWidth} 0;
    letter-spacing: ${latoLetterSpacing};
    line-height: ${baseLineHeight};
    background: ${({ isActive }) => (isActive ? colorAppBackground : colorAppShadedBackground)};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        opacity: 0;
        color: ${colorAppIcon};
        transition: opacity ${`${TRANSITION_TIMEOUT}ms`} ease-in-out;

        &:hover {
            color: ${colorAppLink};
        }
    }

    &:last-child {
        box-shadow: ${`0 ${baseShadowCast} ${baseShadowBlur} ${colorAppBorder}`};
        margin-bottom: ${containerPaddingXs};
    }

    &:hover {
        color: ${colorAppLink};
        span {
            opacity: 1;
        }
    }
`;

const TicketStylingTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const TicketStylingLabel = styled.h2`
    font-size: ${headlineSmallFontSize};
`;

const TicketStylingSubLabel = styled.h2`
    font-size: ${subheadlineSmallFontSize};
`;

const TicketStylingEnabledDot = styled.div`
    height: 0.25rem;
    width: 0.25rem;
    background-color: ${({ isVisible }) => (isVisible ? colorAppSuccess : 'transparent')};
    border-radius: 50%;
    margin-right: ${buttonLargePaddingS};
`;

const LabelEnabledWrapper = styled.div`
    display: flex;
    align-items: center;
`;

const getLastEditedLabel = (label) =>
    `${TICKET_SUB_LABEL_LAST_EDITED} ${moment(label).format('MMMM Do YYYY, h:mm:ss A')}`;

const FormStyleEditorTicketHeader = ({ label, subLabel, lastEdited, handleOnClick, ticketPanelType }) => (
    <TicketStylingTab data-qa={`${TICKET_HEADER_QA}__${ticketPanelType}`} onClick={handleOnClick} isActive={lastEdited}>
        <LabelEnabledWrapper>
            <TicketStylingEnabledDot isVisible={lastEdited} />
            <TicketStylingTextWrapper>
                <TicketStylingLabel>{label}</TicketStylingLabel>
                <TicketStylingSubLabel>{lastEdited ? getLastEditedLabel(lastEdited) : subLabel}</TicketStylingSubLabel>
            </TicketStylingTextWrapper>
        </LabelEnabledWrapper>
        <span>
            <PaintBrush />
        </span>
    </TicketStylingTab>
);

FormStyleEditorTicketHeader.propTypes = {
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    lastEdited: PropTypes.number,
    handleOnClick: PropTypes.func.isRequired,
    ticketPanelType: PropTypes.string.isRequired,
};

FormStyleEditorTicketHeader.defaultProps = {
    subLabel: '',
    lastEdited: null,
};

export default FormStyleEditorTicketHeader;
